import React from 'react';
import classes from "./Lineups.module.css";
import TeamLineups from './TeamLineups';

const Lineups = ({homeTeam,awayTeam}) => {
    console.log({homeTeam,awayTeam});
    return (
        <div className={classes.line_up_container}>
            <div className={classes.home_team_info}>
                <div className={classes.home_team_info_sub}>
                    <img
                        src={homeTeam?.team?.logo}
                        className={classes.home_team_logo}
                        alt={homeTeam?.team?.name}
                    />
                    <p className={classes.home_team_name}>
                        {homeTeam?.team?.name}
                    </p>
                </div>

                <p className={classes.home_team_formation}>
                    {homeTeam?.formation}
                </p>
            </div>
            <div className={classes.line_up_sub_container}>
                <img
                    src="/assets/images/football-ground.jpg"
                    alt="football ground"
                    className={classes.ground}
                />
                <div className={classes.home_team}>
                    <TeamLineups
                        homeTeam={true}
                        team={homeTeam?.team}
                        coach={homeTeam?.coach}
                        startXI={homeTeam?.startXI}
                        formation={homeTeam?.formation}
                    />
                </div>
                <div className={classes.away_team}>
                    <TeamLineups
                        homeTeam={false}
                        team={awayTeam?.team}
                        coach={awayTeam?.coach}
                        startXI={awayTeam?.startXI}
                        formation={awayTeam?.formation}
                    />
                </div>
            </div>
            <div className={classes.home_team_info}>
                <div className={classes.home_team_info_sub}>
                    <img
                        src={awayTeam?.team?.logo}
                        className={classes.home_team_logo}
                        alt={awayTeam?.team?.name}
                    />
                    <p className={classes.home_team_name}>
                        {awayTeam?.team?.name}
                    </p>
                </div>

                <p className={classes.home_team_formation}>
                    {awayTeam?.formation}
                </p>
            </div>
        </div>
    )
}

export default Lineups